import { extractRescheduleSaleChanges } from '@src/domains/sale-changes/core/extractRescheduleSaleChanges';
import type { DetailedSaleItem } from '@src/domains/sale-items';
import type { SaleChange } from '@src/domains/sale-changes/types/saleChange';

export function getLastRescheduleSaleChange(saleItem: DetailedSaleItem): SaleChange | null {
  const rescheduleSaleChanges = extractRescheduleSaleChanges(saleItem);

  if (!rescheduleSaleChanges.length) return null;

  return rescheduleSaleChanges[rescheduleSaleChanges.length - 1]!;
}
